import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-crear-empresa-dialog',
  templateUrl: './crear-empresa-dialog.component.html',
  styleUrls: ['./crear-empresa-dialog.component.css']
})
export class CrearEmpresaDialogComponent {

  cuit: string = '';
  razonSocial: string = '';
  contacto: string = '';
  calle: string = '';
  puerta: string = '';
  codigoPostal: string = '';
  guardando: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CrearEmpresaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    public snackBar: MatSnackBar
  ) {
    // Si viene un CUIT precargado desde el componente padre
    if (data && data.cuit) {
      this.cuit = data.cuit;
    }
  }

  crearEmpresa() {
    // Validaciones
    if (!this.cuit || this.cuit.length < 11) {
      this.snackBar.open('Ingrese un CUIT válido (11 dígitos)', 'Cerrar', { duration: 3000 });
      return;
    }

    if (!this.razonSocial || this.razonSocial.trim() === '') {
      this.snackBar.open('Ingrese una razón social', 'Cerrar', { duration: 3000 });
      return;
    }

    this.guardando = true;

    const payload = {
      cuit: this.cuit.replace(/-/g, ''), // Enviar sin guiones
      razon: this.razonSocial,
      contacto: this.contacto,
      respo: '',
      cct: '',
      idsec: '',
      calle: this.calle,
      puerta: this.puerta,
      cp: this.codigoPostal
    };

    this.http.post(`${environment.backendUrl}/api/empresas/insertar`, payload, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          this.guardando = false;
          this.snackBar.open('✓ Empresa ' + this.razonSocial + ' creada correctamente', 'Cerrar', { duration: 4000, panelClass: 'snackbar-success' });
          setTimeout(() => {
            this.dialogRef.close({
              cuit: this.cuit,
              razonSocial: this.razonSocial,
              contacto: this.contacto,
              calle: this.calle,
              puerta: this.puerta,
              codigoPostal: this.codigoPostal
            });
          }, 1500);
        },
        (error) => {
          this.guardando = false;
          console.error('Error creando empresa:', error);
          const codigo = error && error.error && error.error.code ? error.error.code : '';
          if (codigo === 'ER_DUP_ENTRY' || (error.status === 500 && JSON.stringify(error.error).includes('Duplicate'))) {
            this.snackBar.open('El CUIT ' + this.cuit + ' ya existe en el sistema.', 'Cerrar', { duration: 5000 });
          } else {
            this.snackBar.open('Error al crear la empresa. Verifique los datos.', 'Cerrar', { duration: 3000 });
          }
        }
      );
  }

  cancelar() {
    this.dialogRef.close();
  }
}
